import * as React from 'react';

import {Radio} from 'shells/radio/radio';
import {RadioGroup} from 'shells/radio/radio-group';

type Props = {
    paymentType: string;
    onUpdateField: (key: string, value: string) => void;
};

export function CreditDebitSelector(props: Props) {
    const {paymentType, onUpdateField} = props;

    return (
        <RadioGroup
            name='paymentType'
            size='big'
            inline={true}
            selectedValue={paymentType}
            onChange={(value) => onUpdateField('paymentType', value)}
        >
            <Radio value='card'>Credit/Debit</Radio>
            <Radio value='bank'>Bank account</Radio>
        </RadioGroup>
    );
}
